

// import React from 'react';
// import { FaCreditCard, FaClipboardList, FaRoad } from 'react-icons/fa';
// import { Swiper, SwiperSlide } from 'swiper/react';
// import 'swiper/css'; // Swiper core styles
// import 'swiper/css/pagination'; // Swiper pagination styles
// import { Pagination } from 'swiper/modules'; // Import pagination module
// import { useMediaQuery } from 'react-responsive'; // For responsive breakpoints

// function Service() {
//   const isMobile = useMediaQuery({ maxWidth: 768 }); // Mobile check (adjust breakpoint if needed)

//   const services = [
//     {
//       icon: <FaCreditCard className="text-[#000] text-4xl" />,
//       title: "Multiple Payment Options",
//       description: "Don't let payment mode come in between you and your dream bike! Choose from credit card, debit card, net banking, or UPI.",
//     },
//     {
//       icon: <FaClipboardList className="text-[#000] text-4xl" />,
//       title: "Flexible Packages Available",
//       description: "Don't let time limit your adventure! Whether it's daily, hourly, or yearly, we've got a rental plan that fits your schedule.",
//     },
//     {
//       icon: <FaRoad className="text-[#000] text-4xl" />,
//       title: "Unlimited Kilometres",
//       description: "Don't let limits hold you back from your adventure! Enjoy limitless rides with our flexible bike rentals, designed for your freedom on the road!",
//     },
//   ];

//   return (
//     <div className="flex flex-col bg-white">
//       <h2 className="text-4xl font-semibold text-[#FF9630] mb-12">Why Ride With Moveonwheels</h2>

//       {isMobile ? (
//         <Swiper
//           modules={[Pagination]}
//           pagination={{ clickable: true }}
//           spaceBetween={16}
//           slidesPerView={1.2} // Show part of the next slide
//           className="w-full"
//         >
//           {services.map((service, index) => (
//             <SwiperSlide key={index}>
//               <div
//                 className="flex flex-col items-start bg-white rounded-lg p-8 h-auto border border-gray-200 
//               shadow-md"
//               >
//                 <div className="mb-4">{service.icon}</div>
//                 <h3 className="text-xl font-semibold text-gray-800 mb-2 text-left">
//                   {service.title}
//                 </h3>
//                 <p className="text-gray-600 text-left">{service.description}</p>
//               </div>
//             </SwiperSlide>
//           ))}
//         </Swiper>
//       ) : (
//         <div className="flex flex-wrap justify-center gap-8 w-full">
//           {services.map((service, index) => (
//             <div
//               key={index}
//               className="flex flex-col items-start bg-white rounded-lg p-8 w-[29%] h-auto border border-gray-200 
//               transition-transform duration-200 hover:-translate-y-2 shadow-md"
//             >
//               <div className="mb-4">{service.icon}</div>
//               <h3 className="text-xl font-semibold text-gray-800 mb-2 text-left">
//                 {service.title}
//               </h3>
//               <p className="text-gray-600 text-left">{service.description}</p>
//             </div>
//           ))}
//         </div>
//       )}
//     </div>
//   );
// }

// export default Service;


import React from 'react';
import { FaCreditCard, FaClipboardList, FaRoad } from 'react-icons/fa';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css'; // Swiper core styles
import 'swiper/css/pagination'; // Swiper pagination styles
import { Pagination } from 'swiper/modules'; // Import pagination module
import { useMediaQuery } from 'react-responsive'; // For responsive breakpoints

function Service() {
  const isMobile = useMediaQuery({ maxWidth: 768 }); 

  const services = [
    {
      icon: <FaCreditCard className="text-[#000] text-4xl" />,
      title: "Multiple Payment Options",
      description: "Don't let payment mode come in between you and your dream bike! Choose from credit card, debit card, net banking, or UPI.",
    },
    {
      icon: <FaClipboardList className="text-[#000] text-4xl" />,
      title: "Flexible Packages Available",
      description: "Don't let time limit your adventure! Whether it's daily, hourly, or yearly, we've got a rental plan that fits your schedule.",
    },
    {
      icon: <FaRoad className="text-[#000] text-4xl" />,
      title: "Unlimited Kilometres",
      description: "Don't let limits hold you back from your adventure! Enjoy limitless rides with our flexible bike rentals, designed for your freedom on the road!",
    },
  ];

  return (
    <div className="flex flex-col bg-white p-4">
      <h2 className="text-2xl sm:text-3xl md:text-4xl font-semibold text-[#FF9630] mb-12  text-center">Why Ride With Moveonwheels</h2>

      {isMobile ? (
        <Swiper
          modules={[Pagination]}
          pagination={{ clickable: true }}
          spaceBetween={16}
          width={435}
          slidesPerView={1.1} 
          loop={true} 
          className="w-full"
        >
          {services.map((service, index) => (
            <SwiperSlide key={index}>
              <div
                className="flex flex-col  bg-white rounded-lg p-6 h-[250px] border border-gray-200 
                shadow-md"
              >
                <div className="mb-4">{service.icon}</div>
                <h3 className="text-xl font-semibold text-gray-800 mb-2 text-left">
                  {service.title}
                </h3>
                <p className="text-gray-600 text-left">{service.description}</p>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      ) : (
        <div className="flex flex-wrap justify-center gap-11 w-full">
          {services.map((service, index) => (
            <div
              key={index}
              className="flex flex-col items-start bg-white rounded-lg p-8 w-[29%] min-h-[300px] border border-gray-200 
              transition-transform duration-200 hover:-translate-y-2 shadow-md"
            >
              <div className="mb-4">{service.icon}</div>
              <h3 className="text-xl font-semibold text-gray-800 mb-2 text-left">
                {service.title}
              </h3>
              <p className="text-gray-600 text-left">{service.description}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default Service;
